import { getters } from '/@/modules/core/app/helpers/store';

export const HasAuthUserMixin = {
  computed: {
    /** @returns {AuthUser} */
    authUser() {
      return getters.auth.getUser();
    }
  }
};
